module.exports = __webpack_public_path__ + "static/media/cash.da378efa.svg";